import { render, staticRenderFns } from "./IncomesCollapsableProduct.vue?vue&type=template&id=66337bce&"
import script from "./IncomesCollapsableProduct.vue?vue&type=script&lang=js&"
export * from "./IncomesCollapsableProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports